exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/vencimientos/vencimientos.component.css
// module id = ../../../../../src/app/components/vencimientos/vencimientos.component.css
// module chunks = main